import { API_BASE, UPLOADS_BASE } from './config';
import defaultArticleImage from '../assets/images/new-artical.jpg';
import defaultDoctorAvatar from '../assets/images/docter-profile.png';
import { getMediaThumbnailUrl } from '../features/admin/utils/youtubeHelpers';
import {
  articleMatchesCategory,
  formatArticleDate,
  formatArticleDateParts,
  formatArticleTags,
  formatArticleUploadTime,
  getArticleTabCategories,
  parseArticleTagLabels,
  resolveArticleMedicalSpecialty,
} from '../features/admin/utils/newsArticleHelpers';

export {
  UPLOADS_BASE,
  formatArticleDate,
  getArticleTabCategories,
  articleMatchesCategory,
  resolveArticleMedicalSpecialty,
};

async function fetchJson(url) {
  const response = await fetch(url);
  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    throw new Error(data.message || `Request failed (${response.status})`);
  }
  return response.json();
}

const slugify = (text, id) => {
  const base = String(text || 'article')
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, '')
    .trim()
    .replace(/\s+/g, '-');
  return base ? `${base}-${id}` : `article-${id}`;
};

export async function fetchNewsArticles(filters = {}) {
  const params = new URLSearchParams();
  if (filters.establishment_id != null) {
    params.set('establishment_id', String(filters.establishment_id));
  }
  if (filters.doctor_id != null) {
    params.set('doctor_id', String(filters.doctor_id));
  }

  const query = params.toString();
  const url = `${API_BASE}/master/news-articles${query ? `?${query}` : ''}`;
  const data = await fetchJson(url);
  return Array.isArray(data) ? data : [];
}

export async function fetchNewsArticleById(id) {
  return fetchJson(`${API_BASE}/master/news-articles/${id}`);
}

export function mapArticleToHomeCardProps(article, specialtyNames = []) {
  const galleryImages = (article.images || [])
    .map((img) => `${UPLOADS_BASE}/uploads/${img.image_path}`)
    .filter(Boolean);
  const image = galleryImages[0] || getMediaThumbnailUrl(article.media_link) || defaultArticleImage;
  const tagLabels = parseArticleTagLabels(article.context_tags);
  const dateParts = formatArticleDateParts(article.publication_date);
  const medicalSpecialty = resolveArticleMedicalSpecialty(article, specialtyNames);

  return {
    id: article.news_article_id,
    slug: slugify(article.article_title, article.news_article_id),
    category: medicalSpecialty,
    medicalSpecialty,
    categories: tagLabels,
    image,
    uploadTime: formatArticleUploadTime(article.created_on),
    date: formatArticleDate(article.publication_date),
    dateLine1: dateParts.line1,
    dateLine2: dateParts.line2,
    publicationName: article.publication_name || '',
    tags: formatArticleTags(article.context_tags),
    title: article.article_title,
    description: article.short_description || '',
    establishmentName: article.establishment_name || '',
    doctorName: article.doctor_name || '',
  };
}

export function getArticleIdFromSlug(slug) {
  const match = String(slug || '').match(/-(\d+)$/);
  return match ? Number(match[1]) : null;
}

export function mapArticleToDetailProps(article, doctorsById = {}, specialtyNames = []) {
  const card = mapArticleToHomeCardProps(article, specialtyNames);
  const doctor = doctorsById[article.doctor_id] || doctorsById[String(article.doctor_id)];

  return {
    ...card,
    content: article.short_description || '',
    publicationName: article.publication_name || '',
    author: {
      name: article.doctor_name || doctor?.doctor_name || article.establishment_name || 'Bizaario Care',
      avatar: doctor?.profile_pic_path
        ? `${UPLOADS_BASE}/uploads/${doctor.profile_pic_path}`
        : defaultDoctorAvatar,
    },
    comments: [],
  };
}
